import { useNavigate, useSearch } from '@tanstack/react-router';
import type { DateRangePickerValue } from '@shigo-ui/ui';

import {
  parsePerformanceAnalyzerRouteSearch,
  serializePerformanceAnalyzerRouteSearch,
} from './performanceAnalyzerRouteSearch';

export function usePerformanceAnalyzerRouteFilters() {
  const navigate = useNavigate({ from: '/reporting/performance-analyzer' });
  const search = useSearch({ from: '/reporting/performance-analyzer' });
  const primaryRange = parsePerformanceAnalyzerRouteSearch(search);

  return {
    primaryRange,
    setPrimaryRange: (range: DateRangePickerValue) => {
      void navigate({
        search: serializePerformanceAnalyzerRouteSearch(range),
        replace: true,
      });
    },
  };
}
